/**
 * Fusos horários do Brasil.
 *
 * A lista é curta de propósito. O sistema atende prefeituras brasileiras, e um
 * seletor com os 400 fusos do banco IANA obriga o gestor a caçar
 * "America/Cuiaba" no meio de "Africa/Ouagadougou" para responder a uma
 * pergunta que tem dezesseis respostas possíveis.
 *
 * São os quatro horários oficiais do país. Cada um traz o `id` do IANA, que é o
 * que o `Intl` entende, e a lista de estados, que é como quem preenche o
 * formulário reconhece o próprio.
 */

export interface BrazilTimezone {
  /** Identificador IANA — o que vai para o `Intl.DateTimeFormat`. */
  readonly id: string;
  /** Como aparece no seletor. */
  readonly label: string;
  /** Diferença para o horário de Brasília, em horas. */
  readonly offsetFromBrasilia: number;
  /** Onde este horário vale, para quem não decora nome de fuso. */
  readonly where: string;
}

export const BRAZIL_TIMEZONES: readonly BrazilTimezone[] = [
  {
    id: 'America/Noronha',
    label: 'Fernando de Noronha (UTC−2)',
    offsetFromBrasilia: 1,
    where: 'Fernando de Noronha e ilhas oceânicas',
  },
  {
    id: 'America/Sao_Paulo',
    label: 'Brasília (UTC−3)',
    offsetFromBrasilia: 0,
    where: 'Sudeste, Sul, Nordeste, Goiás, Tocantins, Distrito Federal, Pará e Amapá',
  },
  {
    id: 'America/Cuiaba',
    label: 'Mato Grosso e Amazônia Ocidental (UTC−4)',
    offsetFromBrasilia: -1,
    where: 'Mato Grosso, Mato Grosso do Sul, Amazonas, Rondônia e Roraima',
  },
  {
    id: 'America/Rio_Branco',
    label: 'Acre (UTC−5)',
    offsetFromBrasilia: -2,
    where: 'Acre e o sudoeste do Amazonas',
  },
];

/** Fuso de Aripuanã, e padrão de quem não escolher. */
export const DEFAULT_TIMEZONE = 'America/Cuiaba';

export const BRAZIL_TIMEZONE_IDS = BRAZIL_TIMEZONES.map((zona) => zona.id);

export function isBrazilTimezone(id: string): boolean {
  return BRAZIL_TIMEZONE_IDS.includes(id);
}

/** O fuso por extenso; o próprio identificador quando não é um dos quatro. */
export function timezoneLabel(id: string): string {
  return BRAZIL_TIMEZONES.find((zona) => zona.id === id)?.label ?? id;
}
